import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="utils--stale-content"
export default class extends Controller {
  reload(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return

    location.reload()
  }
}
